// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__xtW23","projectsContainer":"Projects_projectsContainer__7GTwU","projectsBlock":"Projects_projectsBlock__-XAPa","title":"Projects_title__22rmt"};